export enum FileUploadTypeEnum {
  Avatar = 'avatar',
  Logo = 'logo',
  Document = 'document'
}
